import { render, staticRenderFns } from "./SpellCheckOptionsInput.vue?vue&type=template&id=1ca07f36&scoped=true&"
import script from "./SpellCheckOptionsInput.vue?vue&type=script&lang=js&"
export * from "./SpellCheckOptionsInput.vue?vue&type=script&lang=js&"
import style0 from "./SpellCheckOptionsInput.vue?vue&type=style&index=0&id=1ca07f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca07f36",
  null
  
)

export default component.exports